import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Form = _resolveComponent("Form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    style: _normalizeStyle({ width: _ctx.$vuetify.display.lgAndUp ? '50%' : '100%' })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Form, null, {
        default: _withCtx(({ meta }) => [
          _createVNode(_component_v_form, {
            id: "focusLockDialogForm",
            onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submitRegistration(_ctx.teilnehmer)), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { sm: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "px-16 pt-10",
                            sm: "12"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", {
                                textContent: _toDisplayString(_ctx.$t('registration.description'))
                              }, null, 8, _hoisted_1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "px-16",
                            sm: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                name: "TVS-Nummer",
                                rules: _ctx.getValidation('teilnehmerApiDto.kundenNummer')
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps({ id: "TvsNummerInput" }, field, {
                                    modelValue: _ctx.teilnehmer.kundenNummer,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teilnehmer.kundenNummer) = $event)),
                                    modelModifiers: { number: true },
                                    label: _ctx.$t('registration.label.tvsnummer') + '*',
                                    placeholder: _ctx.$t('registration.placeholder.tvsnummer'),
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_Field, {
                                name: "Anrede",
                                rules: _ctx.getValidation('teilnehmerApiDto.anrede')
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_select, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.anredeTypCode,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.teilnehmer.anredeTypCode) = $event)),
                                    items: _ctx.anredeList,
                                    label: _ctx.$t('registration.label.anrede') + '*',
                                    "error-messages": errors,
                                    "menu-props": { attach: '#focusLockDialogForm' }
                                  }), null, 16, ["modelValue", "items", "label", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.teilnehmer.titelTypCode,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teilnehmer.titelTypCode) = $event)),
                                items: _ctx.titelList,
                                label: _ctx.$t('registration.label.titel'),
                                "menu-props": { attach: '#focusLockDialogForm' }
                              }, null, 8, ["modelValue", "items", "label"]),
                              _createVNode(_component_Field, {
                                name: "Vorname",
                                rules: _ctx.getValidation('teilnehmerApiDto.vorname')
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.vorname,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teilnehmer.vorname) = $event)),
                                    label: _ctx.$t('registration.label.vorname') + '*',
                                    placeholder: _ctx.$t('registration.label.vorname'),
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_Field, {
                                name: "Nachname",
                                rules: _ctx.getValidation('teilnehmerApiDto.name')
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.name,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.teilnehmer.name) = $event)),
                                    label: _ctx.$t('registration.label.nachname') + '*',
                                    placeholder: _ctx.$t('registration.label.nachname'),
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.teilnehmer.firma,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.teilnehmer.firma) = $event)),
                                label: _ctx.$t('registration.label.firma'),
                                placeholder: _ctx.$t('registration.label.firma')
                              }, null, 8, ["modelValue", "label", "placeholder"]),
                              _createVNode(_component_Field, {
                                name: "Strasse",
                                rules: _ctx.getValidation('teilnehmerApiDto.strasse')
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.strasse,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.teilnehmer.strasse) = $event)),
                                    label: _ctx.$t('registration.label.strasse') + '*',
                                    placeholder: _ctx.$t('registration.label.strasse'),
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.teilnehmer.zusatz,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.teilnehmer.zusatz) = $event)),
                                label: _ctx.$t('registration.label.adresszusatz'),
                                placeholder: _ctx.$t('registration.label.adresszusatz')
                              }, null, 8, ["modelValue", "label", "placeholder"]),
                              _createVNode(_component_Field, {
                                name: "Plz",
                                rules: _ctx.getValidation('teilnehmerApiDto.plz')
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.plz,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.teilnehmer.plz) = $event)),
                                    modelModifiers: { number: true },
                                    label: _ctx.$t('registration.label.plz') + '*',
                                    placeholder: _ctx.$t('registration.label.plz'),
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.teilnehmer.ort,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.teilnehmer.ort) = $event)),
                                label: _ctx.$t('registration.label.ort'),
                                placeholder: _ctx.$t('registration.label.ort')
                              }, null, 8, ["modelValue", "label", "placeholder"]),
                              _createVNode(_component_Field, {
                                name: "Telefon",
                                rules: _ctx.getValidation('teilnehmerApiDto.telefon') + '|valid_swiss_telephone_number'
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.telefon,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.teilnehmer.telefon) = $event)),
                                    label: _ctx.$t('registration.label.telefon') + '*',
                                    placeholder: "+41 31 111 22 33",
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_Field, {
                                name: "TelefonMobil",
                                rules: _ctx.getValidation('teilnehmerApiDto.telefonMobil') + '|valid_swiss_telephone_number'
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.telefonMobil,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.teilnehmer.telefonMobil) = $event)),
                                    label: _ctx.$t('registration.label.telefonmobil') + '*',
                                    placeholder: "+41 77 111 22 33",
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_Field, {
                                name: "Sprache",
                                rules: _ctx.getValidation('teilnehmerApiDto.sprache')
                              }, {
                                default: _withCtx(({ errors, handleChange, handleBlur }) => [
                                  _createVNode(_component_v_select, {
                                    "model-value": _ctx.teilnehmer.sprache,
                                    items: _ctx.spracheList,
                                    label: _ctx.$t('registration.label.sprache') + '*',
                                    "error-messages": errors,
                                    "menu-props": { attach: '#focusLockDialogForm' },
                                    "onUpdate:modelValue": 
                                            (val) => {
                                                _ctx.teilnehmer.sprache = val;
                                                handleChange(val);
                                            }
                                        ,
                                    onBlur: handleBlur
                                  }, null, 8, ["model-value", "items", "label", "error-messages", "onUpdate:modelValue", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_Field, {
                                name: "Email",
                                rules: _ctx.getValidation('teilnehmerApiDto.email')
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.teilnehmer.email,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.teilnehmer.email) = $event)),
                                    label: _ctx.$t('registration.label.email') + '*',
                                    placeholder: _ctx.$t('registration.label.email'),
                                    "error-messages": errors
                                  }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_Field, {
                                name: "Referrer",
                                rules: "required"
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_select, _mergeProps(field, {
                                    modelValue: _ctx.referrerSelection,
                                    "onUpdate:modelValue": [
                                      _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referrerSelection) = $event)),
                                      _ctx.handleReferrerChange
                                    ],
                                    items: _ctx.referrerItemList,
                                    label: _ctx.$t('registration.label.referrer') + '*',
                                    "error-messages": errors,
                                    "menu-props": { attach: '#focusLockDialogForm' }
                                  }), null, 16, ["modelValue", "items", "label", "error-messages", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              (_ctx.isSonstiges)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    modelValue: _ctx.teilnehmer.referrer,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.teilnehmer.referrer) = $event)),
                                    label: _ctx.$t('registration.label.referrer.sonstiges'),
                                    placeholder: _ctx.$t('registration.label.referrer.sonstiges')
                                  }, null, 8, ["modelValue", "label", "placeholder"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { class: "px-16 py-10" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                sm: "6",
                                class: "pt-0 d-flex justify-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    type: "submit",
                                    disabled: !meta.valid || _ctx.requiredFieldsFilled || _ctx.registrationButtonDisabled,
                                    large: "",
                                    color: "primary",
                                    class: "py-3 px-6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('registration.button.confirm')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                sm: "6",
                                class: "pt-0 d-flex justify-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    large: "",
                                    color: "grey-lighten-3",
                                    link: "",
                                    class: "py-3 px-6",
                                    onKeydown: _withKeys(_ctx.handleLastTabKeydown, ["tab"]),
                                    onClick: _ctx.openVetdataInNewTab
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('registration.button.cancel')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onKeydown", "onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}